export default {
  nav: {
    onlineSms: 'オンラインSMS',
    rentNumber: 'ソフトウェア開発',
    esim: '宝くじ',
    apiConnection: 'API',
    agent: 'ライブチャット',
    blog: 'シェア',
    help: 'ヘルプ',
    register: '登録',
    login: 'ログイン'
  },
  header: {
    memberCenter: 'メンバーセンター',
    logout: 'ログアウト',
    logoutSuccess: 'ログアウトしました'
  },
  common: {
    user: 'ユーザー',
    chinese: '中国語',
    loading: '読み込み中...',
    noData: 'データなし',
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    back: '戻る',
    submit: '送信',
    search: '検索',
    success: '成功',
    error: 'エラー',
    warning: '警告',
    info: '情報',
    copySuccess: 'コピーしました',
    copyFailed: 'コピーに失敗しました',
    operationSuccess: '操作成功',
    operationFailed: '操作に失敗しました',
    networkError: 'ネットワークエラー、後でもう一度お試しください',
    payWith: '支払い方法',
    unit: '',
    yes: 'はい',
    no: 'いいえ',
    all: 'すべて',
    more: 'もっと見る',
    next: '次へ',
    prev: '前へ'
  },
  home: {
    title: 'SMS受信プラットフォーム',
    subtitle: 'スパムや個人情報漏洩なしで、ソーシャルネットワークやオンラインストアに登録。',
    btnGetNumber: '番号取得',
    btnRent: 'レンタル',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — SMS受信用電話番号レンタル',
    sectionDesc: 'SMS-MANなら、200以上の国から仮想番号をレンタルしてSMSを受信できます。レンタル期間：24時間、1週間、1ヶ月。',
    sectionDesc2: '多くのオンラインアプリに登録する必要がある場合に便利です。番号が合わない場合（SMSを受信できなかった場合）は、20分以内に無料でキャンセルできます！',
    howItWorks: '使い方を確認',
    stepsTitle: '3ステップで仮想番号をレンタル',
    step1Title: '国を選択',
    step2Title: 'レンタル期間を設定',
    step3Title: '番号をレンタル',
    step1Desc: 'インド、メキシコ、イスラエル',
    step2Desc: '時間、日、週、月',
    step3Desc: 'レンタル期間',
    whyChoose: 'SMS-MANを選ぶ理由',
    feature1Title: 'ワンタイム番号の購入、または最大1ヶ月のレンタル',
    feature2Title: 'SMS受信用ワンタイム番号',
    feature2Desc: '仮想番号を通じてSMSを受信するサービスを選択。どのウェブサイトやアプリからでもワンタイムSMS認証コードを受信。',
    feature3Title: '番号をレンタル',
    feature3Desc: '電話番号をレンタルして、どのウェブサイトやアプリからでも無制限にSMSを受信。',
    usageLimit: '利用制限',
    usageLimitDesc: '最大20分',
    usageLimitDesc2: '最大30日',
    youCanReceive: 'SMSを受信可能',
    youCanReceiveDesc: '購入時に選択した1つのウェブサイト/アプリ 無制限',
    youCanReceiveDesc2: '利用可能なすべてのサービス',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: 'すべての利用可能なサービス',
    btnRentNow: '今すぐレンタル',
    btnRentNumber: '番号をレンタル',
    aboutText: '「SMS-Man」では、SMS受信用の仮想番号を作成できます。レンタル番号は、電話番号が必要なほとんどのプラットフォームで動作します。',
    aboutText2: '多くのウェブサイトでSMS認証が必要です。これらのサービスは通常、海外の電話番号では利用できません。SIMカードを購入するのは手間もお金もかかります。約$0.5-1を支払うだけ。',
    aboutText3: 'SMS-MANは200以上の国/地域でサービスを提供。仮想番号をレンタルして、どのウェブサイトやアプリからでもSMSを受信できます。',
    aboutText4: '「SMS-Man」で番号をレンタルするメリット：',
    aboutText5: '1つの仮想番号で200以上のウェブサイトやアプリに登録可能。',
    aboutText6: '個人の電話番号が漏洩してスパムを受ける心配はありません。',
    aboutText7: '1つのプラットフォームで異なる国の番号を管理し、SMSを受信。',
    aboutText8: 'プロフェッショナルなスキルは不要、価格もとても安い。',
    aboutText9: 'いつでもどこでもオンラインで電話番号をレンタル！',
    registerTitle: '登録',
    registerDesc: '個人情報を入力する必要はありません、3ステップだけ',
    regStep1: 'ウェブサイトでメールを入力',
    regStep1Desc: 'メールアドレスを入力してパスワードを作成。',
    regStep2: 'メールボックスでメールを確認',
    regStep2Desc: '入力したメールに確認メールを送信しました。メールを開いて確認リンクをクリックしてください。',
    regStep3: 'おめでとうございます！登録完了',
    regStep3Desc: 'SMS-MANのすべてのサービスにログインして利用できます。',
    onlineServiceTitle: '便利なオンラインSMS受信サービス',
    joinTelegram: 'オンラインチャットに参加',
    joinTelegramDesc: 'Telegramグループに参加して最新情報を受け取りましょう',
    telegramBot: 'Telegramボット',
    telegramBotDesc: 'TelegramボットでSMSを受信',
    userGroup: 'ユーザーグループ',
    userGroupDesc: 'ユーザーグループに参加してサポートを受けましょう',
    desktopApp: 'デスクトップアプリケーション',
    desktopAppDesc: 'デスクトップアプリケーションをダウンロード',
    btnJoin: '参加',
    btnConnect: '接続',
    btnDownload: 'ダウンロード',
    professionalTitle: 'プロフェッショナル向けソリューション',
    professionalDesc: 'SMS-MANは一般ユーザーだけでなく、大量のアカウント登録や制限付きリソースへのアクセスが必要なプロフェッショナル向けツールも提供。',
    apiConnect: 'API接続',
    apiConnectDesc: 'バッチSMS受信・送信、作業の自動化',
    readMore: '続きを読む',
    faqTitle: 'よくある質問',
    faq1: 'SMSプラットフォームサービスとは？どのように動作しますか？',
    faq2: 'SMS-MANとは？',
    faq3: 'SMS受信用の使い捨てSIMカードは必要ですか？',
    faq4: 'SMS-MANで個人情報は安全ですか？',
    faq5: 'SMS受信の成功を確認するには？',
    faq6: 'SMSプラットフォームは本当に安全ですか？',
    faq7: 'SMS受用にSMS-Manを選ぶ理由は？',
    footer: {
      smsPlatform: 'SMSプラットフォーム',
      rentNumber: '番号レンタル',
      apiConnection: 'API',
      referral: '紹介',
      partnership: 'パートナーシップ',
      partners: 'パートナー',
      blog: 'シェア',
      help: 'ヘルプ',
      privacyPolicy: 'プライバシーポリシー',
      termsOfUse: '利用規約',
      paymentRefund: '支払いと返金',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: 'ログイン',
    email: 'メール',
    password: 'パスワード',
    emailPlaceholder: 'メールを入力',
    passwordPlaceholder: 'パスワードを入力',
    forgotPassword: 'パスワードを忘れましたか？',
    noAccount: 'アカウントをお持ちでないですか？',
    register: '登録',
    socialLogin: 'ソーシャルプラットフォームでログイン',
    btnLogin: 'ログイン',
    captchaSuccess: '成功！',
    loginFailed: 'ログインに失敗しました'
  },
  register: {
      title: '登録',
      email: 'メールを入力',
      codePlaceholder: '認証コードを入力',
      sendCode: 'コード取得',
      sending: '送信中...',
      codeSent: 'コードが送信されました。メールを確認してください',
      password: 'パスワードを作成',
      confirmPassword: 'パスワード確認',
      agreeTerms: '登録することで同意したものとみなされます',
      terms: '利用規約',
      hasAccount: 'すでにアカウントをお持ちですか？',
      login: 'ログイン',
      socialLogin: 'またはソーシャルアカウントでログイン',
      btnRegister: '登録',
      registering: '登録中...',
      captchaSuccess: '成功！',
      passwordMismatch: 'パスワードが一致しません',
      registerFailed: '登録に失敗しました',
      codeExpired: 'コードの有効期限が切れました。再取得してください',
      codeError: '認証コードが正しくありません'
    },
  member: {
    sidebar: {
      receiveSms: 'SMS受信',
      premiumSms: 'プレミアムSMS',
      rentNumber: '番号レンタル',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: 'チャージ',
      loyalty: 'ロイヤルティ',
      earn: '稼ぐ',
      partnership: 'パートナーシップ',
      api: 'API',
      instructions: '使い方',
      feedback: 'フィードバック',
      help: 'ヘルプ',
      chatGroup: 'ライブチャット',
      chatManage: 'チャット管理',
      receptionRecords: '受信記録',
      chatPlan: 'チャットプラン',
	  chatSettings: 'チャット設定',
      lotteryGroup: '宝くじ',
      lotteryBets: 'ベット記録'
    },
    header: {
      desktopClient: 'デスクトップクライアント',
      desktopClientDesc: 'パソコンで直接SMSを受信',
      telegramBot: 'Telegramボット',
      telegramBotDesc: 'Telegramで直接SMSを受信',
      try: '試す',
      connect: '接続',
      balance: '残高',
      recharge: 'チャージ',
      language: '言語'
    },
    avatarMenu: {
      settings: '設定',
      profile: 'プロフィール表示',
      logout: 'ログアウト'
    },
    receiveSms: {
      title: 'SMS受信',
      selectService: 'サービスを選択',
      searchService: 'サービスで検索',
      selectCountry: '国を選択',
      searchCountry: '国で検索',
      sort: '並び替え',
      buySms: 'SMS購入',
      doubleSms: 'ダブルSMS',
      btnBuySms: 'SMS購入'
    },
    premiumSms: {
      title: 'プレミアムSMS',
      selectService: 'サービスを選択',
      searchService: 'サービスで検索',
      selectCountry: '国を選択',
      searchCountry: '国で検索',
      sort: '並び替え',
      buySms: 'SMS購入',
      doubleSms: 'ダブルSMS',
      btnBuySms: 'SMS購入'
    },
    rentNumber: {
      title: '番号レンタル',
      subtitle: 'SMS受信用のみ',
      wholeNumber: '全体番号',
      byService: 'サービス別',
      selectCountry: '1. 国を選択',
      search: '検索',
      setDuration: '2. 期間を設定',
      hour: '時間',
      day: '日',
      week: '週',
      month: '月',
      rentNumber: '3. 番号をレンタル',
      cost: '費用',
      btnRent: 'レンタル',
      rentDesc: '番号とレンタル期間に対して支払います。選択した期間中、無制限にSMSを受信できます。購入後のキャンセル、返金、早期終了はできません。',
      premiumTitle: 'プレミアム番号',
      premiumDesc: 'より高い配信率とより強力な信頼性を持つ高品質な番号にアクセス',
      btnPremium: 'プレミアムを取得'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. 国/地域を選択',
      searchCountry: '国または地域を検索',
      all: 'すべて',
      mixed: 'ミックス',
      showAll: 'すべて表示',
      selectPlan: '2. プランを選択',
      esimInfo: 'eSIMは支払い後すぐにアクティベートされます。インストールQRコードがアカウントに提供されます。',
      phoneSupport: 'お使いの携帯電話はeSIMに対応していますか？',
      phoneSupportDesc: '*#06#をダイヤルして、EIDが表示されればeSIMに対応しています。',
      howToConfig: 'eSIMでモバイルデータを設定する方法',
      selectType: '3. eSIMタイプを選択',
      allType: 'すべて',
      dataOnly: 'データのみ',
      dataAndCall: 'データ + 通話',
      btnRecharge: 'チャージ'
    },
    recharge: {
      title: '残高チャージ',
      payMethod: '支払い方法',
      usdtDesc: 'USDT TRC-20 でチャージ、管理者確認後に到账',
      onlyUsdt: 'USDT のみ',
      fillAmount: 'チャージ金額',
      otherAmount: 'カスタム金額',
      btnPay: 'チャージする',
      submitting: '送信中...',
      payDesc: '注文作成後に USDT 住所とQRコードが表示されます',
      invalidAmount: '有効な金額を入力してください（最低 $1）',
      rechargeFailed: 'チャージに失敗しました',
      rechargeFailedRetry: 'チャージに失敗しました、もう一度お試しください',
      historyTitle: 'チャージ履歴',
      thOrderNo: '注文番号',
      thAmount: '金額',
      thStatus: 'ステータス',
      thTime: '日時',
      statusPending: '確認待ち',
      statusPaid: '到账済み',
      statusCancelled: 'キャンセル済み',
      scanToPay: 'QRコードで支払い',
      payAmount: '支払い金額',
      usdtAddress: 'USDT TRC-20 受取住所',
      copy: 'コピー',
      copied: 'コピー済み',
      orderNo: '注文番号',
      waitingConfirm: '管理者の確認を待っています。支払い後に自動更新されます',
      paySuccess: 'チャージ到账',
      paySuccessDesc: 'チャージが正常に到账されました'
    },
    feedback: {
      title: 'お問い合わせ',
      name: 'お名前',
      email: 'メール',
      question: 'ご質問',
      btnSend: '送信',
      captchaSuccess: '成功！',
      support247: '24時間年中無休のサポート',
      responseTime: '平均応答時間 約15分',
      weekendWork: '週末も通常通りサポート',
      chatSupport: 'チャットサポート',
      youtube: 'YouTube'
    },
    partnership: {
      title: 'SIMカードで信頼できるサービスで稼ぐ',
      desc1: 'SMS受信用の電話番号（SIMカード）をお持ちの方は、このページがおすすめです。',
      desc2: 'SMS-ManでSIMカードを使って稼ぎ始めましょう！',
      whatTogether: '一緒に何ができますか？',
      whatTogetherDesc: 'SMS-ManはオンラインSMS受信用の国際プラットフォームです。現在20万人のアクティブユーザーと、1日1億件以上のSMSリクエストがあります。',
      whatTogetherDesc2: 'それでも足りない：顧客の需要は急速に伸びています。だからこそ、あなたを探しています。',
      howContact: 'SMS-Manへの連絡方法は？',
      restApi: 'REST API',
      restApiDesc: 'APIファイルと直接支払いアカウントをご提供ください。当社のシステムに統合します。',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: 'GSM/GoIP機器をお持ち',
      gsmGoipDesc2: '専用ソフトウェアでシステムに接続',
      gsmGoipDesc3: '専用ダッシュボードで統計を追跡',
      gsmGoipDesc4: '収入はSIMカードの国によって異なります',
      apiLink: 'APIリンク',
      apiLinkDesc1: '例：この形式の番号をお持ちの場合：',
      apiLinkDesc2: '条件に従って番号を購入'
    },
    instructions: {
      title: 'SMS-MANでFacebookに登録',
      step1: 'ステップ1. 番号を取得。',
      step1Desc: 'ワンタイム',
      receiveSms: 'SMS受信',
      or: 'または',
      rentNumber: '番号レンタル',
      step2: 'ステップ2. 取得した番号をコピー。',
      step2Desc: '横のアイコンをクリック、または番号を選択してCtrl+Cでコピー。',
      step3: 'ステップ3. Facebook登録情報を入力。',
      step3Desc: 'facebook.comにアクセス、「新しいアカウントを作成」をクリック。'
    },
    loyalty: { title: 'ロイヤルティプログラム' },
    earn: { title: '稼ぐ' },
    api: { title: 'APIドキュメント' },
    help: { title: 'ヘルプセンター' },
    lotteryBets: {
      title: 'ベット記録',
      allTypes: 'すべてのタイプ',
      allResults: 'すべての結果',
      win: '勝ち',
      lose: '負け',
      pending: '保留中',
      searchPeriod: '期間を検索...',
      totalBets: '合計ベット',
      totalWin: '勝ち',
      totalLose: '負け',
      totalPending: '保留中',
      totalProfit: '合計損益',
      period: '期間',
      lotteryType: 'タイプ',
      playType: 'プレイ',
      betContent: 'ベット内容',
      betAmount: '金額',
      odds: 'オッズ',
      drawNumbers: '抽選番号',
      result: '結果',
      profit: '損益',
      time: '時間',
      totalRecords: '{0} 件',
      prevPage: '前へ',
      nextPage: '次へ'
    },
    profile: {
      title: 'プロフィール',
      pageDesc: 'アカウント詳細を表示',
      userId: 'ユーザーID',
      balance: '残高',
      registerTime: '登録日時',
      lastLogin: '最終ログイン',
      accountStatus: 'アカウント状態',
      langSetting: '言語',
      statusActive: '有効',
      statusInactive: '無効',
      apiInfo: 'API情報',
      apiKey: 'APIキー',
      notGenerated: '未生成',
      copy: 'コピー',
      usageStats: '使用統計',
      smsOrders: 'SMS注文',
      rechargeCount: 'チャージ回数',
      totalSpent: '合計使用額',
      chatSessions: 'チャットセッション'
    },
    settings: {
      title: '設定',
      pageDesc: 'アカウントとセキュリティを管理',
      changePassword: 'パスワード変更',
      currentPassword: '現在のパスワード',
      currentPasswordPh: '現在のパスワードを入力',
      newPassword: '新しいパスワード',
      newPasswordPh: '新しいパスワードを入力（6文字以上）',
      confirmNewPassword: '新しいパスワードの確認',
      confirmNewPasswordPh: '新しいパスワードを再入力',
      saving: '保存中...',
      saveChanges: '変更を保存',
      changeEmail: 'メール変更',
      currentEmail: '現在のメール',
      newEmail: '新しいメール',
      newEmailPh: '新しいメールを入力',
      accountSecurity: 'アカウントセキュリティ',
      apiKey: 'APIキー',
      notGenerated: '未生成'
    },
	chatSettings: {
	  title: 'チャット設定',
	  avatar: 'チャットアバター',
	  avatarTip: '推奨サイズ：200x200、JPG/PNG対応、最大5MB',
	  channelName: 'チャット名',
	  channelNamePlaceholder: 'チャットの表示名を入力してください',
	  welcomeMsg: 'デフォルトの歓迎メッセージ',
	  welcomeMsgPlaceholder: '訪問者がチャットに入室した際に自動送信される歓迎メッセージ',
	  save: '設定を保存',
	  saving: '保存中...',
	  saveSuccess: '保存しました',
	  saveFailed: '保存に失敗しました'
	},
    chatPlan: {
      title: 'チャットプラン',
      currentPlan: '現在のプラン',
      perMonth: '/月',
      seats: 'エージェント',
      seatsUnit: '',
      maxSessions: '最大セッション',
      expiryTime: '有効期限',
      daysLeft: '（残り{0}日）',
      autoRenew: '自動更新',
      btnRenew: '今すぐ更新',
      btnUpgrade: 'アップグレード',
      plansTitle: 'プラン',
      recommended: 'おすすめ',
      current: '現在',
      selectPlan: 'プランを選択',
      renewalTitle: '更新履歴',
      thOrderId: '注文ID',
      thPlan: 'プラン',
      thAmount: '金額',
      thPayment: '支払い',
      thDuration: '期間',
      thExpiry: '有効期限',
      thStatus: 'ステータス',
      renewModalTitle: 'プラン更新',
      month: '{0} ヶ月',
      discount10: '10% OFF',
      discount7: '30% OFF',
      confirmRenew: '更新を確認',
      renewSuccess: '更新完了！{0} ヶ月延長',
	  kaiqiok: '正常に有効化されました',
	  guanbiok: '正常に無効化されました',
      renewFailed: '更新に失敗しました',
      retryLater: 'もう一度お試しください',
      switchSuccess: '{0} に切り替えました',
      switchFailed: '切り替えに失敗しました'
    },
    chatManage: {
      sessionList: 'セッション',
      sessionCount: '{0} セッション',
      searchVisitor: '訪問者を検索...',
      online: 'オンライン',
      offline: 'オフライン',
      source: 'ソース:',
      btnTransfer: '転送',
      btnEndSession: 'セッション終了',
      btnEnd: '終了',
      inputPlaceholder: 'メッセージを入力...',
      send: '送信',
      me: '自分',
      selectSession: 'セッションを選択してチャットを開始',
      emoji: '絵文字',
      file: 'ファイル'
    },
    receptionRecords: {
      title: '受信記録',
      allStatus: 'すべてのステータス',
      completed: '完了',
      ongoing: '進行中',
      missed: '不在',
      searchVisitor: '訪問者名を検索...',
      visitor: '訪問者',
      source: 'ソース',
      agent: 'エージェント',
      startTime: '開始時間',
      endTime: '終了時間',
      messages: 'メッセージ',
      satisfaction: '満足度',
      status: 'ステータス',
      action: '操作',
      view: '表示',
      notRated: '未評価',
      totalRecords: '{0} 件',
      prevPage: '前へ',
      nextPage: '次へ',
      detailTitle: 'セッション詳細',
      visitorEmail: '訪問者メール:',
      sourceLabel: 'ソース:',
      agentLabel: 'エージェント:',
      durationLabel: '所要時間:',
      minute: '分'
    },
    agentManage: {
      title: 'エージェント管理',
      addAgent: 'エージェントを追加',
      agent: 'エージェント',
      account: 'アカウント',
      status: 'ステータス',
      currentSessions: '対応中',
      lastOnline: '最終ログイン',
      action: '操作',
      online: 'オンライン',
      offline: 'オフライン',
      enable: '有効',
      disable: '無効',
      edit: '編集',
      delete: '削除',
      loading: '読み込み中...',
      empty: 'エージェントがいません。右上の追加をクリック',
      addTitle: 'エージェントを追加',
      editTitle: 'エージェントを編集',
      nameLabel: 'エージェント名',
      namePlaceholder: '例：サポート張',
      accountLabel: 'ログインアカウント',
      accountPlaceholder: '例：kefu1',
      passwordLabel: 'ログインパスワード',
      passwordPlaceholder: '6文字以上',
      resetPasswordLabel: 'パスワードをリセット（空欄で変更なし）',
      resetPasswordPlaceholder: '空欄の場合は現在のパスワードを保持',
      statusLabel: 'ステータス',
      cancel: 'キャンセル',
      saving: '保存中...',
      save: '保存',
      nameRequired: 'エージェント名を入力してください',
      passwordMin: 'パスワードは6文字以上必要です',
      accountRequired: 'ログインアカウントを入力してください',
      saveSuccess: '保存しました',
      saveFailed: '保存に失敗しました',
      opFailed: '操作に失敗しました',
      networkError: 'ネットワークエラー、後でもう一度お試しください',
      deleteSuccess: '削除しました',
      deleteFailed: '削除に失敗しました',
      toggleConfirm: 'エージェント「{1}」を{0}してもよろしいですか？',
      deleteConfirm: 'エージェント「{0}」を削除してもよろしいですか？元に戻せません！'
    }
  },
  help: {
    title: 'ヘルプページ',
    subtitle: 'SMS-Manサービスの使い方とよくある質問への回答',
    popularQuestions: 'よくある質問',
    q1: '登録後SMSを待つ時間は？',
    q1a: 'SMSの待ち時間は5分以内です。5分以内にSMSが届かない場合は、番号をキャンセルして別の番号を購入してください。',
    q2: 'SMSは何件受信できますか？',
    q3: '最小チャージ金額はいくらですか？',
    q4: 'リストにないサービスでもSMSを受信できますか？',
    q5: 'SMSが届かない場合、どうすればいいですか？',
    q6: '「サービスが一時的に利用できません」エラーとは？',
    q7: 'APIキーはどこで確認できますか？',
    q8: 'どうやって私たちと稼げますか？',
    serviceGuide: 'サービスガイド',
    serviceGuideTitle: 'オンライン登録方法は？',
    serviceGuideDesc: 'アカウント登録、電話番号を入力、国を選択、サービスを選択、購入をクリック、SMSを待ちます。',
    howToRent: 'サービス用にレンタルするには？',
    howToRentDesc: 'サービスを選択、国を選択、レンタル期間を選択、レンタルをクリック。',
    howToBuy: 'ワンタイムSMSを購入するには？',
    howToBuyDesc: 'サービスを選択、国を選択、SMS購入をクリック。',
    howToUseNumber: 'レンタル番号を使うには？',
    howToUseNumberDesc: '注文ページから番号をコピー、対象ウェブサイトに入力、SMSを待ちます。',
    footer: {
      smsPlatform: 'SMSプラットフォーム',
      rentNumber: '番号レンタル',
      apiConnection: 'API',
      referral: '紹介',
      partnership: 'パートナーシップ',
      partners: 'パートナー',
      blog: 'シェア',
      help: 'ヘルプ',
      privacyPolicy: 'プライバシーポリシー',
      termsOfUse: '利用規約',
      paymentRefund: '支払いと返金',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: '記事センター',
    recentPosts: '最新記事',
    archives: 'アーカイブ',
    readMore: '続きを読む',
    comments: '閲覧数',
    category: 'カテゴリ',
    currentCategory: '現在のカテゴリ:',
    clearFilter: '✕ フィルターをクリア',
    allCategories: 'すべてのカテゴリ',
    articleCategories: 'カテゴリ'
  },
  articleDetail: {
    loading: '読み込み中...',
    notFound: '記事が見つかりません',
    backToList: '← 記事一覧に戻る',
    home: 'ホーム',
    blog: 'シェア',
    views: '閲覧数',
    share: 'シェア:',
    relatedArticles: '関連記事'
  },
  homeApi: {
    title: '開発者向け',
    subtitle: 'SMS-Manとサービスを接続し、自動で番号を購入するためのAPIドキュメント',
    legacyApi: 'レガシーAPI',
    apiV2: 'API 2.0',
    miniApi: 'Mini API',
    apiDesc: 'APIインターフェースでSMS-Manから自動でSMSを購入・受信できます。サービスは自動同期されます。自動受信するにはAPIをリセットしてください。APIの利用にはAPIキーも必要です。プロフィールページで確認できます。すべてのAPIリクエストはGETまたはPOSTです。すべてのリクエストにtokenパラメータとAPIキーを含める必要があります。',
    getBalance: '残高取得',
    getBalanceDesc: '現在のアカウント残高を取得',
    params: 'パラメータ',
    field: 'フィールド',
    type: 'タイプ',
    required: '必須',
    value: '値',
    result: '結果',
    possibleErrors: '考えられるエラー',
    rateLimit: 'レート制限',
    getNumber: '番号取得',
    getNumberDesc: '指定国の番号を取得、country_idを指定',
    getSms: 'SMS取得',
    getSmsDesc: '指定注文のSMSを取得',
    setStatus: 'ステータス設定',
    setStatusDesc: '注文ステータスを変更',
    getCountries: '国一覧取得',
    getCountriesDesc: '利用可能なすべての国を取得',
    getServices: 'サービス一覧取得',
    getServicesDesc: '利用可能なすべてのサービスを取得'
  },
  onlineSms: {
    hero: {
      title: 'オンラインSMS認証プラットフォーム',
      desc: 'スパムや個人情報漏洩なしで、ソーシャルネットワークやオンラインストアに登録。',
      viewNumbers: '番号を見る',
      receiveCode: 'コードを受信'
    },
    countries: {
      title: '国/地域を選択',
      subtitle: '200以上の国からSMS認証用の仮想番号を選択',
      services: 'サービス',
      select: '選択'
    },
    services: {
      title: '今日の人気サービス',
      buy: '購入'
    },
    howItWorks: {
      title: '3ステップで仮想番号をレンタル',
      subtitle: '使い方を確認',
      step1Title: '国を選択',
      step1Desc: '200以上のオプションから仮想番号の国を選択',
      step2Title: 'サービスを選択',
      step2Desc: 'SMSを受信したいアプリまたはサービスを選択',
      step3Title: 'SMSを受信',
      step3Desc: '仮想番号を取得してオンラインで認証コードを受信'
    },
    features: {
      fastTitle: '高速認証',
      fastDesc: '数秒で認証コードを取得、待ち時間なし',
      safeTitle: 'プライバシー保護',
      safeDesc: '仮想番号で個人情報を保護',
      globalTitle: 'グローバルカバレッジ',
      globalDesc: '200以上の国でサービスをサポート'
    },
    cta: {
      title: '今すぐ登録して認証を開始',
      desc: '登録時に無料クレジットを取得し、仮想番号サービスを体験',
      register: '無料登録'
    },
    faq: {
      title: 'よくある質問',
      q1: 'オンラインSMS認証とは？',
      a1: 'オンラインSMS認証は、仮想番号を使ってSMS認証コードを受信するサービスで、実際の電話番号を使用しません。',
      q2: '番号はどれくらい使えますか？',
      a2: 'サービスによりますが、20分から30日まで使えます。',
      q3: 'プライバシーはどのように保護されますか？',
      a3: 'すべての番号は仮想で、使用後に破棄されるため、実際の電話番号が露出することはありません。'
    }
  },
  esim: {
    hero: {
      title: 'eSIMをオンラインで購入',
      desc: 'グローバルモバイルデータを即座に。QRコードで数秒でeSIMをアクティベートし、高額なローミング料金にさよなら。',
      learnMore: '詳しく',
      countries: '国',
      network: 'ネットワーク',
      activation: 'アクティベーション'
    },
    howItWorks: {
      title: '3つの簡単ステップで接続',
      step1Title: 'プランを選択',
      step1Desc: '必要な国/地域とデータプランを選択',
      step2Title: '支払い & QRコード取得',
      step2Desc: '支払い後、eSIMアクティベーションQRコードを受信',
      step3Title: 'スキャンしてオンライン',
      step3Desc: '携帯電話の設定でQRコードをスキャンしてeSIMをアクティベート'
    },
    whyEsim: {
      title: 'eSIMの利点',
      subtitle: '海外で接続するためのスマートな方法',
      f1Title: 'ローミング料金なし',
      f1Desc: '現地のモバイルネットワークを使用して高額な国際ローミング料金を回避',
      f2Title: '即座にアクティベート',
      f2Desc: 'QRコードをスキャンしてアクティベート、物理SIMカードの待ち時間なし',
      f3Title: 'メインSIMを維持',
      f3Desc: 'eSIMをデータ用に使いながら、メイン番号を引き続き使用'
    },
    cta: {
      title: 'ローミング料金なしで旅行する準備は？',
      desc: '数分でeSIMをアクティベートし、世界中で接続'
    },
    comparison: {
      title: 'eSIM vs. 現地SIMカード',
      r1: '旅行前に設定',
      r2: '即座にアクティベート',
      r3: 'カードの差し替えなし',
      r4: 'メイン番号を維持',
      r5: '固定の予測可能な価格',
      r6: 'メールのみで登録',
      r7: '暗号通貨対応'
    },
    plus: {
      title: 'eSIM plus SMS-MANの既存機能',
      desc: 'データプランと仮想番号、SMS認証を1つのアカウントで'
    },
    faq: {
      title: 'eSIMに関する質問',
      q1: 'eSIMとは？どのように動作しますか？',
      a1: 'eSIMは物理カードなしでモバイルデータをアクティベートする組み込みSIMです。QRコードをスキャンするだけでアクティベートできます。',
      q2: 'どのデバイスがSMS-MAN eSIMに対応していますか？',
      a2: 'ほとんどの最新スマートフォンがeSIMに対応しています。iPhone XS以降、Samsung Galaxy S20以降。',
      q3: 'アクティベーションはどのくらい速いですか？',
      a3: '通常は数秒です。QRコードをスキャンしてすぐに使えます。',
      q4: 'eSIMはメイン番号を置き換えますか？',
      a4: 'いいえ、eSIMはデータ用です。メイン番号はそのままです。',
      q5: '後でデータをチャージや追加購入できますか？',
      a5: 'はい、アカウントからいつでも追加データパックを購入できます。'
    }
  },
  agent: {
    hero: {
      title: 'SMS-MANエージェントになる',
      desc: 'SMS-MANサービスを宣伝してコミッションを獲得し、不労所得を構築。',
      becomeAgent: 'エージェントになる',
      learnMore: '詳しく'
    },
    benefits: {
      title: 'エージェント特典',
      subtitle: 'SMS-MANエージェントになる理由',
      b1Title: '高率コミッション',
      b1Desc: '最大20%の紹介コミッションを獲得',
      b2Title: '不労所得',
      b2Desc: '紹介先が支出を続ける限りコミッションを獲得',
      b3Title: '専用サポート',
      b3Desc: '問題解決のための専用エージェントアカウントマネージャー',
      b4Title: 'グローバルマーケット',
      b4Desc: '地理的制限なく世界中のユーザーに宣伝'
    },
    howItWorks: {
      title: '始め方',
      step1Title: 'アカウント登録',
      step1Desc: 'SMS-MANアカウントを作成し、エージェント申請',
      step2Title: '紹介リンクを取得',
      step2Desc: '固有の紹介リンクとマーケティング資料を受け取る',
      step3Title: 'コミッションを獲得',
      step3Desc: 'ユーザーがリンク経由で登録・支出するとコミッションを獲得'
    },
    commission: {
      title: 'コミッションレベル',
      l1Name: 'ジュニアエージェント',
      l1Desc: '月間1-50人の紹介ユーザー',
      l2Name: 'ミッドエージェント',
      l2Desc: '月間51-200人の紹介ユーザー',
      l3Name: 'シニアエージェント',
      l3Desc: '月間200人以上の紹介ユーザー'
    },
    features: {
      title: 'エージェントツール',
      f1Title: 'ダッシュボード',
      f1Desc: '紹介データとコミッション収益をリアルタイムで表示',
      f2Title: '紹介リンク',
      f2Desc: '正確なコンバージョン追跡付きの固有紹介リンク',
      f3Title: '高速引き出し',
      f3Desc: 'いつでも複数の支払い方法にコミッションを引き出し',
      f4Title: '専用サポート',
      f4Desc: '優先対応のエージェント専用サポートチャンネル'
    },
    cta: {
      title: '始める準備はできましたか？',
      desc: '今すぐ登録してSMS-MANエージェントになり、不労所得の旅を始めましょう',
      joinNow: '今すぐ参加'
    }
  },
  softwareDev: {
    heroTitle: 'プロフェッショナルなソフトウェア開発サービス',
    heroDesc: '要件分析から納品まで、フルスタックのカスタム開発ソリューションを提供。Webアプリケーション、モバイルアプリ、管理システム、API開発など。',
    btnViewCases: '事例を見る',
    btnContact: 'お問い合わせ',
    servicesTitle: 'サービス',
    servicesSubtitle: '多様なビジネスニーズに対応する総合的なソフトウェア開発サービス',
    service1Title: 'Webアプリケーション開発',
    service1Desc: '企業サイト、ECプラットフォーム、SaaSシステム、管理ダッシュボードのフルスタック開発',
    service2Title: 'モバイルアプリ開発',
    service2Desc: 'ネイティブiOS/AndroidアプリとReact Native/Flutterによるクロスプラットフォーム開発',
    service3Title: 'API開発',
    service3Desc: 'RESTful API、WebSocketリアルタイム通信、サードパーティシステム統合',
    service4Title: '自動化システム',
    service4Desc: 'データ収集、自動化スクリプト、定时タスク、ビジネスプロセス自動化',
    service5Title: 'ゲーム/エンターテイメントシステム',
    service5Desc: 'カードゲーム、宝くじシステム、インスタントメッセージ、リアルタイムインタラクティブプラットフォーム',
    service6Title: 'クラウドデプロイメント',
    service6Desc: 'サーバーデプロイ、CI/CDパイプライン、Dockerコンテナ化、パフォーマンス最適化',
    techStackTitle: '技術スタック',
    casesTitle: 'プロジェクト事例',
    casesSubtitle: '納品済みプロジェクトのショーケース',
    projectShare: 'シェア',
    processTitle: '開発プロセス',
    process1Title: '要件ヒアリング',
    process1Desc: 'プロジェクト要件を深く理解し、スコープと技術アプローチを定義',
    process2Title: 'ソリューション設計',
    process2Desc: '詳細な技術アーキテクチャ、データベース設計、UIプロトタイプ',
    process3Title: '開発',
    process3Desc: 'アジャイル開発で定期的にデモと進捗共有',
    process4Title: 'テスト＆最適化',
    process4Desc: '機能、パフォーマンス、セキュリティの包括的テスト',
    process5Title: 'デプロイメント',
    process5Desc: 'サーバーデプロイ、ドメイン設定、SSL証明書、モニタリング',
    process6Title: '保守＆サポート',
    process6Desc: 'システム安定性を確保するための継続的な技術サポートとバグ修正',
    stats1Label: '納品プロジェクト',
    stats2Label: '満足クライアント',
    stats3Label: '経験年数',
    stats4Label: 'クライアント満足度',
    contactTitle: 'プロジェクトをお持ちですか？',
    contactDesc: 'アイデアをお聞かせください。プロフェッショナルな開発ソリューションとお見積もりを提供します',
    contactOnline: 'オンラインサポート',
    contactBtn: '今すぐ相談'
  },
  lotteryPage: {
    heroTitle: 'ライブ宝くじ抽選センター',
    heroDesc: '複数宝くじの即時抽選、リアルタイムデータ同期、公正で透明',
    statLottery: '宝くじ種類',
    statNonStop: '途切れない抽選',
    statSync: 'リアルタイム同期',
    periodDraw: '第{0}回',
    currentRemain: '現在{0}、残り{1}',
    dragonTiger: '1-5 ドラゴン/タイガー',
    championSum: 'チャンピオンサム',
    betNow: '今すぐベット',
    tabHistory: '履歴',
    tabRoad: 'ロード分析',
    tabHotCold: 'ホット/コールド',
    tabTrend: 'チャンピオントレンド',
    rulesTitle: 'ルール',
    rule1Title: 'ドラゴン/タイガー',
    rule1Desc: '最初と最後の抽選番号を比較。最初がドラゴン、最後がタイガー。',
    rule2Title: 'チャンピオンサム',
    rule2Desc: 'チャンピオンとランナーアップの番号を合計し、合計で大小と奇偶を判定。',
    rule3Title: '大小 奇偶',
    rule3Desc: '位置または合計に基づいて大小（6-10が大、1-5が小）と奇偶を判定。',
    rule4Title: 'ロード分析',
    rule4Desc: '履歴ロードマップチャートを通じて抽選パターンとトレンドを分析。',
    dragon: 'ドラゴン',
    tiger: 'タイガー',
    big: '大',
    small: '小',
    odd: '奇数',
    even: '偶数',
    countdownMin: '分',
    countdownSec: '秒',
    nameSpeedRacing: 'スピードレーシング',
    nameSgAirship: 'SG飛行船',
    nameSpeedAirship: 'スピード飛行船',
    nameLuckyAirship: 'ラッキー飛行船',
    logoRacing: 'レーシング',
    logoAirship: '飛行船'
  },
  apiDocs: {
    pageTitle: 'APIドキュメント',
    pageSubtitle: 'SMS、宝くじ抽選、カスタマーサービスなどのAPIインターフェースを迅速に統合',
    tabSms: 'SMS API',
    tabLottery: '宝くじAPI',
    tabChat: 'ライブチャットAPI',
    versionLegacy: 'レガシーAPI',
    versionV2: 'API 2.0',
    versionMini: 'Mini API',
    baseAddress: 'ベースURL',
    requestMethod: 'メソッド',
    returnFormat: 'レスポンス形式',
    authMethod: '認証',
    requestParams: 'リクエストパラメータ',
    field: 'フィールド',
    type: 'タイプ',
    required: '必須',
    description: '説明',
    yes: 'はい',
    no: 'いいえ',
    returnExample: 'レスポンス例',
    smsDesc: 'SMS APIは、仮想番号取得、SMS受信、ステータス管理の完全な機能を提供し、200以上の国をサポート。',
    lotteryDesc: '宝くじAPIは、リアルタイム抽選データクエリ、履歴、トレンド分析を提供し、複数の宝くじタイプをサポート。',
    chatDesc: 'ライブチャットAPIは、セッション管理、メッセージング、エージェント管理を提供し、WebSocketリアルタイム通信とRESTfulインターフェースをサポート。',
    ep: {
      getBalance: '残高取得', getNumber: '番号取得', getSms: 'SMS取得',
      checkBalance: '残高確認', createOrder: '注文作成', querySms: 'SMSクエリ',
      setStatus: 'ステータス設定', getCountries: '国取得', getServices: 'サービス取得',
      getLotteryList: '抽選一覧取得', getLotteryHistory: '抽選履歴取得',
      getLotteryTypes: '宝くじタイプ取得', liveDraw: 'ライブ抽選',
      lotteryHistory: '抽選履歴', lotteryStats: '抽選統計',
      latestDraw: '最新抽選', createSession: 'セッション作成',
      sendMessage: 'メッセージ送信', getMessageHistory: 'メッセージ履歴取得',
      agentStatus: 'エージェントステータス', closeSession: 'セッション終了', quickSend: 'クイック送信'
    },
    epd: {
      getBalance: '現在のアカウント残高をクエリ', getNumber: 'SMS受信用の仮想番号を取得',
      getSms: '番号のSMS認証コードを取得', checkBalance: '現在の利用可能残高を取得',
      createOrder: 'SMS注文を作成して仮想番号を取得', querySms: 'ポーリングして注文SMS内容を取得',
      setStatus: '注文ステータスを設定（受信/キャンセル/継続）',
      getCountries: 'サポートされているすべての国を取得', getServices: 'サポートされているすべてのSMSサービスを取得',
      getLotteryList: 'すべての宝くじの最新抽選情報を取得', getLotteryHistory: '宝くじタイプの抽選履歴を取得',
      getLotteryTypes: 'サポートされているすべての宝くじタイプを取得', liveDraw: '宝くじの最新抽選結果を取得',
      lotteryHistory: 'ページネーション付きの抽選履歴を取得', lotteryStats: '抽選統計を取得（ホット/コールド番号、欠番値）',
      latestDraw: 'すべての宝くじの最新抽選を取得（簡略版）', createSession: '新しいサポートセッションを作成',
      sendMessage: 'セッションにメッセージを送信', getMessageHistory: 'セッションのチャット履歴を取得',
      agentStatus: 'オンラインエージェントリストとステータスを取得', closeSession: '特定のセッションを終了',
      quickSend: 'セッション作成とメッセージ送信を一度に実行',
      getNumberSimple: 'ワンクリックで番号を取得（簡略版）', getSmsSimple: 'SMS内容を取得',
      createSessionV2: '自動エージェント割り当て付きのサポートセッションを作成', sendMessageV2: '特定のセッションにメッセージを送信'
    }
  },
  liveChat: {
    heroTitle: 'ライブチャットシステム',
    heroDesc: 'WebSocketベースのリアルタイムカスタマーサービスチャットプラットフォーム。マルチエージェントコラボレーション、スマートルーティング、メッセージ履歴、ファイル転送をサポートし、顧客に24時間年中無休のインスタントサービスを提供。',
    btnFreeTrial: '無料トライアル',
	catedengl: ' カスタマーサービスログイン ',
    btnDemo: 'PC版クライアントをダウンロード',
    previewName: '王エージェント',
    previewStatus: '● オンライン',
    previewMsg1: 'こんにちは！何かお手伝いできますか？',
    previewMsg2: 'サービスについて知りたいです',
    previewMsg3: 'もちろんです、ご紹介させていただきます...',
    inputPlaceholder: 'メッセージを入力...',
    featuresTitle: 'コア機能',
    featuresSubtitle: '満足度を向上させる包括的なカスタマーサービスソリューション',
    feature1Title: 'リアルタイムメッセージング',
    feature1Desc: 'WebSocketベースのミリ秒単位のメッセージ配信でスムーズな会話',
    feature2Title: 'マルチエージェントコラボレーション',
    feature2Desc: '複数のエージェントが同時にオンライン、スマートセッションルーティング',
    feature3Title: 'メッセージ履歴',
    feature3Desc: '完全なチャット履歴で検索・エクスポート可能、トレーニングや参考用に',
    feature4Title: 'ファイル転送',
    feature4Desc: '画像、ドキュメントなどのファイルタイプを送受信',
    feature5Title: 'スマートルーティング',
    feature5Desc: 'エージェントの負荷とスキルタグに基づいて顧客を自動割り当て',
    feature6Title: '分析＆レポート',
    feature6Desc: 'セッション、応答時間、満足度などのリアルタイム統計',
    stepsTitle: 'クイックセットアップ',
    step1Title: 'アカウント登録',
    step1Desc: '管理者アカウントを作成、会社情報とサポートチームを設定',
    step2Title: 'コード埋め込み',
    step2Desc: 'ウェブサイトに1行のコードを埋め込んでチャットウィジェットを表示',
    step3Title: 'サービス開始',
    step3Desc: 'エージェントがログインして顧客の受信と返信を開始',
    dashboardTitle: '強力な管理パネル',
    dashboardDesc: 'エージェントステータス、セッションデータ、顧客満足度をリアルタイムでモニタリング',
    dashFeature1: 'リアルタイムエージェントステータスとセッション数',
    dashFeature2: 'セッションルーティングルールと自動割り当て',
    dashFeature3: 'エージェント勤務時間とパフォーマンス統計',
    dashFeature4: '顧客満足度評価とフィードバック',
    dashFeature5: 'チャット履歴の検索とエクスポート',
    dashFeature6: 'カスタムクイック返信とナレッジベース',
    dashStat1: '本日のセッション',
    dashStat2: '満足度',
    dashStat3: '平均応答',
    dashStat4: 'オンラインエージェント',
    pricingTitle: '料金プラン',
    pricingBadge: 'おすすめ',
    pricingPeriod: '/月',
    btnSelectPlan: 'プランを選択',
    planBasic: 'ベーシック',
    planPro: 'プロフェッショナル',
    planEnterprise: 'エンタープライズ',
    ctaTitle: 'カスタマーサービスを改善する準備は？',
    ctaDesc: '今すぐ登録してすべての機能を無料で試す',
    ctaBtn: '無料で始める',
    pf1Basic: '1エージェント', pf2Realtime: 'リアルタイムチャット', pf3History: 'メッセージ履歴',
    pf4Reports: '基本レポート', pf5Email: 'メールサポート',
    pf1Agents: '10エージェント', pf4AdvReports: '高度なレポート', pf5Smart: 'スマートルーティング',
    pf6File: 'ファイル転送', pf7Priority: '優先サポート',
    ef1Unlimited: '無制限エージェント', ef2All: 'すべての機能', ef3Api: 'APIアクセス',
    ef4Private: 'プライベートデプロイメント', ef5Dedicated: '専用サポート', ef6Sla: 'SLA保証'
  },
  apiMsg: {
    userNotFound: 'このメールアドレスは登録されていません', wrongPassword: 'パスワードが正しくありません', accountDisabled: 'このアカウントは無効化されています',
    agentNotFound: '担当者アカウントが存在しません', agentDisabled: 'この担当者アカウントは無効化されています',
    notLogin: '先にログインしてください', tokenExpired: 'ログインの有効期限が切れました。再度ログインしてください',
    emailRequired: 'メールアドレスを入力してください', emailInvalid: 'メールアドレスの形式が正しくありません',
    emailPasswordRequired: 'メールアドレスとパスワードは必須です', accountPasswordRequired: 'アカウントとパスワードは必須です',
    agentAccountRequired: '担当者アカウントとパスワードは必須です',
    passwordMin: 'パスワードは6文字以上必要です', newPasswordMin: '新しいパスワードは6文字以上必要です',
    emailExists: 'このメールアドレスは既に登録されています', usernameExists: 'このユーザー名は既に使われています',
    captchaWrong: '認証コードが正しくありません', captchaExpired: '認証コードの有効期限が切れました。再度取得してください',
    paramError: 'パラメータが不正です', paramIncomplete: 'すべての項目を入力してください', missingId: 'ID が指定されていません',
    nothingToUpdate: '更新する内容がありません', invalidStatus: '状態の値が不正です', indexOutOfRange: 'インデックスが範囲外です',
    missingChannelCode: 'チャネルコードがありません', channelNotFound: 'チャネルが見つかりません', channelClosed: 'このチャネルは停止中です',
    noChatChannel: 'この会員はサポートチャネルを有効にしていません', chatPlanExpired: 'サポートプランの有効期限が切れているため利用できません',
    noAgentOnlineRetry: '現在オンラインの担当者はいません。後ほど再度お試しください',
    targetAgentInvalid: '対象の担当者が存在しないか無効です', agentNoOperate: '担当者が存在しないか、操作権限がありません',
    sessionNotFound: 'セッションが見つかりません', sessionMismatch: 'セッションが一致しません',
    noPermissionTransfer: 'このセッションは転送できません', noPermissionClose: 'このセッションは終了できません',
    noPermissionDelete: 'このセッションは削除できません',
    chatHasHistory: 'このセッションには履歴があるため削除できません', clientOnline: '顧客がオンライン中のため削除できません',
    onlyAgentRecall: '取り消しできるのは担当者からのメッセージのみです',
    balanceInsufficient: '残高が不足しています', rechargeMinAmount: '最低チャージ金額は 1 ドルです',
    orderNotFound: '注文が見つかりません', orderCancelled: 'この注文は既にキャンセルされています', orderConfirmed: 'この支払いは既に確認済みです',
    orderNotPayable: '現在の注文状態ではこの操作はできません',
    planNotFound: 'プランが見つかりません', serviceNotFound: 'サービスが見つかりません', articleNotFound: '記事が見つかりません',
    numberUnavailable: 'この番号は利用できません', noAvailableNumber: '利用可能な番号がありません',
    numberExists: 'この番号は既に存在します', rentalNotFound: 'レンタル記録が見つかりません',
    agentLimitReached: 'プランの担当者数上限に達しました', emailSendFailed: 'メールの送信に失敗しました。後ほど再度お試しください'
  },
  clientDownload: {
    badge: '公式デスクトップクライアント',
    heroTitle: 'カスタマーサポートクライアントのダウンロード',
    heroDesc: 'サポート担当者向けに作られたデスクトップクライアント。複数セッションの同時対応、リアルタイム通知、定型文返信、担当者間の転送により、すべてのお客様に効率的に対応できます。',
    winDownload: 'Windows 版をダウンロード',
    winHint: 'Windows 10 / 11',
    macDownload: 'macOS 版をダウンロード',
    macHint: 'macOS 10.15 以降',
    previewAlt: 'サポートクライアントの画面プレビュー',
    notice: 'ダウンロード後に解凍するだけで実行でき、インストールは不要です。開発元が確認できない旨の警告が表示された場合は、システム設定で実行を許可してください。',
    featuresTitle: '主な機能',
    featuresSubtitle: '問い合わせ対応の多い現場のためのデスクトップツール。Web 版より安定して高速に動作します',
    f1Title: '複数セッションの管理',
    f1Desc: '左側のセッション一覧がリアルタイムに更新され、未読メッセージが強調表示されるため、複数のお客様を同時に対応しても取りこぼしません。',
    f2Title: 'リアルタイム通知',
    f2Desc: 'WebSocket の常時接続により、訪問者のメッセージをミリ秒単位で受信。切断時は自動で再接続します。',
    f3Title: '定型文返信',
    f3Desc: 'よく使う文言をワンクリックで送信。入力の手間を減らし、応答速度を大きく向上させます。',
    f4Title: '転送と連携',
    f4Desc: 'セッションを他の担当者へ転送でき、複雑な案件もチームで対応できます。',
    stepsTitle: '3 ステップで開始',
    s1Title: 'ダウンロードして解凍',
    s1Desc: 'お使いのシステムに合わせて Windows 版または macOS 版を選び、解凍して起動します。',
    s2Title: '担当者アカウントでログイン',
    s2Desc: '会員センターで作成したサポートアカウントでログインすると、所属チャネルのセッションが自動で同期されます。',
    s3Title: '対応を開始',
    s3Desc: '訪問者のメッセージがリアルタイムに届きます。定型文と転送機能で効率的に対応できます。',
    ctaTitle: '担当者アカウントをお持ちでない方',
    ctaDesc: '会員センターで担当者アカウントを作成して、すぐに業務を開始できます。',
    ctaBtn: '会員センターへ'
  },
  visitorChat: {
    noAgentOnline: '現在オンラインのエージェントがいません。エージェントがオンラインになると、お送りいただいたメッセージに返信します。',
    online: 'オンライン',
    offline: 'オフライン',
    connecting: '接続中...',
    defaultTitle: 'オンラインカスタマーサービス',
    defaultWelcome: 'こんにちは！オンラインカスタマーサービスへようこそ。何かお手伝いできることはありますか？',
    channelNotFound: 'チャネルが存在しないか、閉鎖されています',
    loadError: '読み込みに失敗しました。後でもう一度お試しください',
    imageTooLarge: '画像サイズは2MBを超えることはできません',
    sendImage: '画像を送信',
    inputPlaceholder: 'メッセージを入力...',
    supportSuffix: 'のカスタマーサービス'
  }
}
